export default "__VITE_ASSET__5b0a7b03__"